module.exports = __webpack_public_path__ + "static/media/tags result.96d94437.jpg";